import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LocalActivation } from '../components/posauth/LocalActivation';
import { CloudApproval } from '../components/posauth/CloudApproval';
import { LocalPosPanel } from '../components/posauth/LocalPosPanel';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PosActivationPage() {
  const [state, setState] = useState({ loading: true });
  const [tokenVersion, setTokenVersion] = useState(0);
  useEffect(() => {
    let live = true;
    fetch(`${API}/api/pos/auth/local/status`, { cache: 'no-store' }).then(async r => {
      if (!live) return;
      if (r.ok) setState({ local: await r.json() });
      else if (r.status === 404 && !['localhost', '127.0.0.1'].includes(window.location.hostname)) setState({ cloud: true });
      else setState({ error: true });
    }).catch(() => { if (live) setState({ error: true }); });
    return () => { live = false; };
  }, []);
  return <main data-testid="pos-activation-page" className="min-h-screen px-5 py-16" style={{ background: 'var(--bg-gradient)', color: 'var(--text-primary)' }}>
    <div className="max-w-md mx-auto space-y-8 min-w-0">
      <Link data-testid="pos-activation-home" to="/" className="text-3xl font-bold" style={{ color: 'var(--accent-green)' }}>RENTOS</Link>
      {state.loading && <p data-testid="pos-activation-loading" role="status">Төлөв шалгаж байна…</p>}
      {state.error && <p data-testid="pos-activation-unavailable" role="alert">Хамгаалагдсан нэвтрэх үйлчилгээ боломжгүй байна.</p>}
      {state.local && <LocalActivation initial={state.local} />}
      {state.cloud && <><LocalPosPanel refreshKey={tokenVersion} /><CloudApproval onLogin={() => setTokenVersion(v => v + 1)} /></>}
    </div>
  </main>;
}